<div #holder class="holder" [ngClass]="{ focused: focused }">
  <!-- <div class="focus-marker"></div> -->
  <div class="left">
    <profile-picture
      [user]="participantDict[comment.created_by].user"></profile-picture>
    <div
      *ngIf="!this.comment.hide"
      class="collapse-marker"
      (click)="hideOneLevel()"></div>
  </div>
  <div class="content">
    <div class="content-top d-xs-none d-md-block">
      <b>
        <name-tag
          [user]="participantDict[comment.created_by].user"
          [hint]="true"
          postfix=":"></name-tag>
      </b>
      <span class="timestamp d-xs-none d-md-block">{{ commentDate }}</span>
    </div>
    <b class="d-md-none">
      <name-tag
        [user]="participantDict[comment.created_by].user"
        [showOrg]="false"></name-tag>
    </b>

    <ng-container *ngIf="!comment.hide">
      <ng-container *ngFor="let segment of segments">
        <br *ngIf="segment.isNewline" />
        <span
          *ngIf="!segment.isNewline && !segment.isMention"
          innerHTML="{{ segment.html }}"></span>
        <span
          class="mentioned-user d-xs-none d-md-block"
          *ngIf="segment.isMention">
          <name-tag [user]="segment.user" [hint]="true"></name-tag>
        </span>
        <span class="mentioned-user d-md-none" *ngIf="segment.isMention">
          <name-tag [user]="segment.user" [showOrg]="false"></name-tag>
        </span>
      </ng-container>

      <div class="d-flex justify-content-end" *ngIf="!preview">
        <button
          class="btn btn-sm fa fa-reply"
          title="reply"
          (click)="reply.emit(comment)"></button>
        <button
          class="btn btn-sm fa fa-trash d-xs-none d-md-block"
          title="remove comment"
          *ngIf="
            permissions.session.data.ideas.comments.delete(session, comment)
          "
          (click)="deleteComment()"></button>
      </div>

      <div
        #repliesholder
        class="replies-holder"
        *ngIf="
          !preview &&
          replies.length > 0 &&
          !comment.hideReplies &&
          !comment.hide
        ">
        <div class="contents">
          <div
            class="reply-holder"
            *ngFor="let _reply of replies"
            title="hide replies">
            <comment
              *ngIf="
                participantDict[_reply.created_by] &&
                participantDict[_reply.created_by].user
              "
              [comment]="_reply"
              [idea]="idea"
              [session]="session"
              [focusedComment]="focusedComment"
              (focusRequest)="focusRequest.emit($event)"
              (reply)="reply.emit($event)"></comment>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-container
  *ngIf="
    !preview && ((replies.length > 0 && comment.hideReplies) || comment.hide)
  ">
  <div class="show-replies-btn" (click)="showOneLevel()">
    <ng-container *ngIf="!comment.hide">show replies</ng-container>
    <ng-container *ngIf="comment.hide">show comment</ng-container>
  </div>
  <br />
</ng-container>
